module.exports = __webpack_public_path__ + "img/the-field-gal-2.7c46969e.jpg";